import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { ReceiptReminderStatusResponse } from 'src/queries/organizations/receiptReminders/receiptReminders.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

// All four endpoints use the authed JSON API request config.

export const getOrgReceiptReminderStatus = async (
  orgId: string,
): Promise<ReceiptReminderStatusResponse> => {
  return getResponseData(
    axios.get<ReceiptReminderStatusResponse>(
      `/organizations/${orgId}/receiptreminderstatus`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getOrgExpenseReportReceiptReminderStatus = async (
  reportId: string,
): Promise<ReceiptReminderStatusResponse> => {
  return getResponseData(
    axios.get<ReceiptReminderStatusResponse>(
      `/orgexpensereports/${reportId}/receiptreminderstatus`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postOrgReceiptReminder = async (orgId: string): Promise<void> => {
  return getResponseData(
    axios.post<void>(
      `/organizations/${orgId}/receiptreminder`,
      {},
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postOrgExpenseReportReceiptReminder = async (
  reportId: string,
): Promise<void> => {
  return getResponseData(
    axios.post<void>(
      `/orgexpensereports/${reportId}/receiptreminder`,
      {},
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
